// import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'
import { getAuth, setStorage, getStorage } from '@/lib/storage'
import { permissionMenu, exchangeAuth } from '@/services'
import account from './account'
import project from './project'
import service from './service'
import notice from './notice'
import inquery from './inquery'
import organization from './organization/index'
import team from './team'
import statistic from './statistic'
import costMaintain from './costMaintain'
import role from './role'
import config from './config/index'
import mix from './mix'
import quit from './quit'
import record from './record'
import merge from './merge'
import universalForm from './universalForm'
import smart from './smart/index'
import i18n from '@/lib/language'
import edm from './edm'
import newFeature from './newFeature'
import orgProjectsSet from './organization/orgProjectsSet'
// Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseinfo: {},
    auth: getAuth(),
    pid: '',
    realbackAuth: getStorage('realbackAuth'),
    dingding: '',
    lang: '',
    qwWork: '',
    socketMessage: {},
    roleDefault: false, // 自定义角色进入项目
    menuDatas: {
      permissionMenuList: [],
      menuLabels: [
        {
          key: 'clue-all',
          name: '线索管理',
          iconClass: 'iconxiansuoguanli',
          link: 'inquery/clue',
          mIconClass: 'iconxiansuoguanli',
          routeName: 'InqueryClue',
          group: 'group1'
        },
        {
          key: 'inquiry-add',
          name: i18n.t('message["1696"]'),
          iconClass: 'iconicon-test66',
          link: 'inquery/create',
          mIconClass: 'iconicon-test2',
          routeName: 'InqueryCreate',
          group: 'group1'
        },
        {
          key: 'inquiry-audit',
          name: i18n.t('message["1697"]'),
          iconClass: 'iconicon-test64',
          mIconClass: 'iconicon-test42',
          link: 'inquery/audit',
          routeName: 'InqueryAudit',
          group: 'group1'
        },
        {
          key: 'inquiry-check-repeat',
          name: i18n.t('message["1698"]'),
          iconClass: 'iconicon-test76',
          mIconClass: 'iconicon-test3',
          link: 'inquery/repeat',
          routeName: 'InqueryRepeat',
          group: 'group1'
        },
        {
          key: 'inquiry-mine',
          name: i18n.t('message["1274"]'),
          iconClass: 'iconicon-test63',
          mIconClass: 'iconicon-test4',
          link: 'inquery/list',
          routeName: 'InqueryList',
          group: 'group2'
        },
        {
          key: 'inquiry-all',
          name: i18n.t('message["909"]'),
          iconClass: 'iconicon-test67',
          mIconClass: 'iconicon-test5',
          link: 'inquery/list',
          routeName: 'InqueryList',
          group: 'group2'
        },
        {
          key: 'work-handover',
          name: i18n.t('message["1699"]'),
          iconClass: 'iconicon-test65',
          routeName: 'quit',
          link: 'quit',
          group: 'group3'
        },
        {
          key: 'universal-form',
          name: i18n.t('message["1244"]'),
          iconClass: 'iconicon-test90',
          routeName: 'smartForm',
          link: 'smart',
          group: 'group3'
        },
        {
          key: 'email-direct-marketing',
          // key: 'edm',
          name: i18n.t('message["1700"]'),
          iconClass: 'iconEDM',
          routeName: 'EmailList',
          link: 'edm/emaillist',
          group: 'group3'
        },
        {
          key: 'statistics',
          name: i18n.t('message["1133"]'),
          iconClass: 'iconicon-test60',
          mIconClass: 'iconicon-test6',
          link: 'data/statistic',
          routeName: 'statistics',
          group: 'group4'
        },
        {
          key: 'cost-maintenance',
          name: i18n.t('message["1703"]'),
          link: 'cost/maintain',
          iconClass: 'iconicon-test62',
          mIconClass: 'iconicon-test10',
          routeName: 'CostMaintain',
          group: 'group4'
        },
        {
          key: 'project-config',
          name: i18n.t('message["1701"]'),
          link: 'config/index',
          routeName: 'configIndex',
          iconClass: 'iconicon-test74',
          group: 'group4'
        },
        {
          key: 'notice-history',
          name: i18n.t('message["1702"]'),
          mIconClass: 'iconicon-test3',
          iconClass: 'iconicon-test82',
          routeName: 'recordNotice',
          link: 'record/notice',
          group: 'group5'
        },
        {
          key: 'work-log',
          name: i18n.t('message["1273"]'),
          mIconClass: 'iconicon-test11',
          iconClass: 'iconicon-test54',
          routeName: 'recorLog',
          link: 'record/worklog',
          group: 'group5'
        }
      ]
    },
    isManage: false
  },
  getters: {
    mixDomain (state) {
      return state.baseinfo.private_cloud_status === 1
        ? state.baseinfo.private_cloud_domain
        : ''
      // return 'http://192.168.8.36:81'
    }
  },
  mutations: {
    setAuth (state, auth) {
      state.auth = auth
    },
    setPid (state, pid) {
      state.pid = pid
    },
    setBaseinfo (state, info) {
      state.baseinfo = info
    },
    setRealbackAuth (state, data) {
      state.realbackAuth = data
      setStorage('realbackAuth', data)
    },
    setMenu (state, data = {}) {
      const { baseinfo = {}, payload: menuData = {} } = data
      const { enableshare } = baseinfo
      // console.log(menuData)

      if (menuData['inquiry-all']) {
        let { child = {} } = menuData['inquiry-all'] || {}
        for (let k in child) {
          if (k === 'inquiry-manager-share') {
            child[k].state = enableshare === 1
          }
        }
      }
      if (menuData['inquiry-mine']) {
        let { child = {} } = menuData['inquiry-mine'] || {}
        for (let k in child) {
          if (k === 'inquiry-share') {
            child[k].state = enableshare === 1
          }
        }
      }
      state.menuDatas.permissionMenuList = menuData
    },
    setBaseInfoField (state, data) {
      const { field, num } = data
      state[field] = num
    },
    setSocketMessage (state, data) {
      state.socketMessage = data
    },
    setRoleDefault (state, type) {
      state.roleDefault = type
    },
    setDingding (state, data) {
      state.dingding = data
    },
    setLang (state, data) {
      state.lang = data
    },
    setQwWork (state, data) {
      state.qwWork = data
    },
    setIsManage (state, b) {
      state.isManage = b
    }
  },
  actions: {
    async setSocketMessage ({ commit }, data) {
      commit('setSocketMessage', data)
    },
    // 获取精准回传项目的auth
    async exchangeAuth ({ commit }, params) {
      const chain = await exchangeAuth()
      chain
        .params(params)
        .onSuccess((payload = {}) => {
          commit('setRealbackAuth', payload.auth)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    async permissionMenu ({ commit }) {
      const chain = await permissionMenu().onNetSuccess(raw => {
        const { data = {} } = raw
        commit('setMenu', data)
      })
      chain.fetch()
      return chain
    },
    addClick () {
      window.onbeforeunload = function (e) {
        return false
      }
    },
    removeClick () {
      window.onbeforeunload = null
    }
  },
  modules: {
    account,
    project,
    service,
    inquery,
    organization,
    role,
    team,
    statistic,
    costMaintain,
    config,
    mix,
    quit,
    record,
    notice,
    merge,
    universalForm,
    smart,
    edm,
    newFeature,
    orgProjectsSet
  },
  plugins: [
    /* createPersistedState({
      key: 'westartrack'
    }) */
  ]
})
